import script from "./LoginPro.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPro.vue?vue&type=script&setup=true&lang=js"

import "./LoginPro.vue?vue&type=style&index=0&id=fde0fcfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fde0fcfc"]])

export default __exports__